import { render, staticRenderFns } from "./move_in.vue?vue&type=template&id=12f36c3d&scoped=true"
import script from "./move_in.vue?vue&type=script&lang=js"
export * from "./move_in.vue?vue&type=script&lang=js"
import style0 from "./move_in.vue?vue&type=style&index=0&id=12f36c3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f36c3d",
  null
  
)

export default component.exports